<template>
  <div class="AgentDetail">
    <div class="datatable-form__header atr-header-wrap mb-4">
      <div class="invoiceList-search_item">
        <el-input v-model="searchagentdetailagentName" type="text" placeholder="Agent Name"></el-input>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="searchagentdetailstudentname" type="text" placeholder="Student Name"></el-input>
      </div>

      <div class="datatable-form__submit text-center">
        <button class="btn btn-success searchbtn" id="btnReceiptSearch" v-on:click="Search('AgentDetail')">Search</button>
      </div>
    </div>
    <div class="">
      <div class="datatable-form__submit text-right"></div>
      <div class="pb-5">
        <!--alexis-->
        <el-tabs v-model="cnTab" type="card">
          <el-tab-pane label="Agent Student Detail" name="first">
            <div class="datatable_group">
              <!--<div>
                                <el-button-group class="pull-right mb-3">
                                    <el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadAsZip()">Download</el-button>
                                    <el-button size="small" type="warning" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadAllAsZip()">Download All CN</el-button>
                                </el-button-group>
                            </div> -->
              <data-tables
                :data="CNListInt"
                :action-col="CNListAction"
                @selection-change="changeSelection"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="CNListTable"
              >
                <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                <el-table-column
                  v-for="item in CNList"
                  :prop="item.prop"
                  :label="item.label"
                  :key="item.prop"
                  :hidden="!item.show"
                  sortable="custom"
                  v-if="item.show"
                >
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <b-modal id="showBatchEmailConfirmationModal" hide-footer title="Send Email Confirmation" size="sm" ref="showBatchEmailConfirmationModal">
      <data-tables :data="selectedCNListInt" v-if="selectedCNListInt.length > 0" width="55" stripe tooltip-effect="light" border ref="selectedListTable">
        <el-table-column v-for="item in selectedCNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmail()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmail('No')">No</el-button>
      </div>
    </b-modal>

    <!--alexis>-->
    <b-modal id="showEditAgentDetailModal" hide-footer title="Edit School Fees" size="small" ref="showEditAgentDetailModal">
      <div class="datatable-form__header atr-header-wrap mb-4">
        <h5 style="display: none">{{ txtEditAgentDetail_EditID }}</h5>
        <div class="invoiceList-search_item">
          Agent Name:
          <h5>{{ txtEditAgentDetail_AgentName }}</h5>
        </div>
        <div class="invoiceList-search_item">
          Student Name:
          <h5>{{ txtEditAgentDetail_StudentName }}</h5>
        </div>

        <div class="invoiceList-search_item">
          Start Date:
          <h5>{{ txtEditAgentDetail_StartDate }}</h5>
        </div>
        <div class="invoiceList-search_item">
          End Date:
          <h5>{{ txtEditAgentDetail_EndDate }}</h5>
        </div>
      </div>

      <div class="datatable-form__header atr-header-wrap mb-4">
        <div class="invoiceList-search_item">School Fee: <el-input v-model="txtEditAgentDetail_SchoolFee" type="text" placeholder="School Fee"></el-input></div>

        <div class="invoiceList-search_item">Remarks: <el-input v-model="txtEditAgentDetail_Remarks" type="text" placeholder="Remarks"></el-input></div>

        <div class="invoiceList-search_item">
          <el-select style="max-width: 150px" v-model="AgtStuStatus" clearable placeholder="Status">
            <el-option v-for="item in AgtStuOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
      </div>

      <div class="invoice-modal_submitBox">
        <strong></strong>
        <el-button size="small" type="primary" v-on:click="btnSaveAgentStudent('Yes')">Save</el-button>
        <el-button size="small" type="danger" v-on:click="btnSaveAgentStudent('No')">Cancel</el-button>
      </div>
    </b-modal>

    <b-modal
      id="showBatchEmailConfirmationModalWithBreakdown"
      hide-footer
      title="Send Email Confirmation With Breakdown"
      size="sm"
      ref="showBatchEmailConfirmationModalWithBreakdown"
    >
      <data-tables :data="selectedCNListInt" v-if="selectedCNListInt.length > 0" width="55" stripe tooltip-effect="light" border ref="selectedListTable">
        <el-table-column v-for="item in selectedCNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmailWithBreakdown()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" :disabled="AuditDisabled" v-on:click="btnSendEmailWithBreakdown('No')">No</el-button>
      </div>
    </b-modal>
    <!--        //testing only: start-->
    <b-modal id="showTestingBModal" hide-footer title="Send Email Confirmation(TEST ONLY!)" size="sm" ref="showTestingBModal">
      <data-tables
        :data="testingselectedCNListInts"
        v-if="testingselectedCNListInts.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in testingSelectedCNList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
        <el-table-column label="Email(TEST)" min-width="100px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.newTestEmail" type="text" placeholder="Email(Key in test email)"></el-input>
          </template>
        </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail('No')">No</el-button>
      </div>
    </b-modal>
    <!--        //testing only: end-->
  </div>
</template>
<script>
import DataSource from '../../data/datasource'
import moment from 'moment'
import Cookies from 'js-cookie'

export default {
  name: 'AgentTracker-CN',
  data() {
    return {
      startupText: '',
      inputFromDate: [],
      inputFromDueDate: [],
      searchagentdetailagentName: '',
      searchagentdetailstudentname: '',

      studNO: '',
      invName: '',

      //alexis
      txtEditAgentDetail_AgentName: 'TEST AGENT NAME',
      txtEditAgentDetail_StudentName: 'TEST STUDENT NAME',
      txtEditAgentDetail_StartDate: '01/01/1900',
      txtEditAgentDetail_EndDate: '12/31/2022',
      txtEditAgentDetail_SchoolFee: '0.00',
      txtEditAgentDetail_Remarks: '',
      txtEditAgentDetail_EditID: '0',
      AgtStuStatus: 'Active',

      txtEditAgentDetail_AgentID: '',
      txtEditAgentDetail_CourseID: '',
      txtEditAgentDetail_SChoolID: '',
      txtEditAgentDetail_StudentID: '',

      AgtStuOptions: [
        {
          value: 'Active',
          label: 'Active',
        },
        {
          value: 'Void',
          label: 'Void',
        },
        {
          value: 'Closed',
          label: 'Closed',
        },
      ],

      cnTab: 'first',
      currentSchoolID: '',
      AgentDetailAgentNameSearch: '',
      AgentDetailDetailNameSearch: '',

      //CNList:start
      CNListAction: {
        label: 'Action',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-el-date-editor',
            },

            handler: row => {
              this.txtEditAgentDetail_AgentName = row.AgentName
              this.txtEditAgentDetail_StudentName = row.StudentName
              this.txtEditAgentDetail_StartDate = row.StartDate
              this.txtEditAgentDetail_EndDate = row.EndDate

              this.txtEditAgentDetail_SchoolFee = row.TotalSchoolFee
              this.txtEditAgentDetail_Remarks = row.Remarks

              this.AgtStuStatus = row.Status

              this.txtEditAgentDetail_EditID = row.Id

              this.txtEditAgentDetail_AgentID = row.AgentId
              this.txtEditAgentDetail_CourseID = row.CourseId
              this.txtEditAgentDetail_SChoolID = row.SchoolId
              this.txtEditAgentDetail_StudentID = row.Student_ID

              this.showBModal('EditAgentDetail')

              //alexis

              //this.studentCourseID = row.PK_Student_Course_ID;
              //this.studentID = row.FK_Student_ID;
              //this.courseStatus = row.SCRS_Status;
              //if (this.studentCourseID) {
              //    this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus);
              //} else {
              //    this.$notify.error({
              //        title: 'Message',
              //        message: 'Error.'
              //    });
              //}
            },
            label: 'Edit',
          },
          // {
          //     props: {
          //         type: 'danger',
          //         icon: 'el-icon-el-date-editor',
          //     },

          //     handler: row => {
          //         this.studentCourseID = row.PK_Student_Course_ID;
          //         this.studentID = row.FK_Student_ID;
          //         this.courseStatus = row.SCRS_Status;
          //         if (this.studentCourseID) {
          //             this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus);
          //         } else {
          //             this.$notify.error({
          //                 title: 'Message',
          //                 message: 'Error.'
          //             });
          //         }
          //     },
          //     label: 'Void'
          // },
          // {
          //     props: {
          //         type: 'primary',
          //         icon: 'el-icon-el-date-editor',
          //     },

          //     handler: row => {
          //         this.studentCourseID = row.PK_Student_Course_ID;
          //         this.studentID = row.FK_Student_ID;
          //         this.courseStatus = row.SCRS_Status;
          //         if (this.studentCourseID) {
          //             this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus);
          //         } else {
          //             this.$notify.error({
          //                 title: 'Message',
          //                 message: 'Error.'
          //             });
          //         }
          //     },
          //     label: 'Agent Comission'
          // },
        ],
      },
      CNListInt: [],
      CNList: [
        {
          prop: 'Id',
          label: 'Id',
          show: false,
        },
        {
          prop: 'AgentName',
          label: 'AgentName',
          show: true,
        },
        {
          prop: 'StudentNo',
          label: 'StudentNo',
          show: true,
        },
        {
          prop: 'StudentName',
          label: 'Student Name',
          show: true,
        },
        {
          prop: 'YearLevel',
          label: 'YearLevel',
          show: true,
        },
        {
          prop: 'TotalSchoolFee',
          label: 'Total School Fee',
          show: true,
        },
        {
          prop: 'StartDate',
          label: 'Start Date',
          show: true,
        },
        {
          prop: 'EndDate',
          label: 'End Date',
          show: true,
        },
        {
          prop: 'Status',
          label: 'Status',
          show: true,
        },
        {
          prop: 'AgentId',
          label: 'AgentId',
          show: false,
        },
        {
          prop: 'CourseId',
          label: 'CourseId',
          show: false,
        },
        {
          prop: 'SchoolId',
          label: 'SchoolId',
          show: false,
        },
        {
          prop: 'Student_ID',
          label: 'Student_ID',
          show: false,
        },
        {
          prop: 'Remarks',
          label: 'Remarks',
          show: false,
        },
      ],

      CNListWithoutPayeeEmailInt: [],
      CNListWithoutPayeeEmail: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'IH_Invoice_Status',
          label: 'Invoice Status',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Credit Note No',
        },
        {
          prop: 'IH_Invoice_Name',
          label: 'Invoice No',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
      ],
      CNListWithoutPayeeEmailAction: {
        label: 'More info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-el-date-editor',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'Edit',
          },
        ],
      },
      //CNList:end

      tempResp: [],
      spdSelection: [],
      zipType: '',
      selectedCNListInt: [],
      testingselectedCNListInts: [],
      testingSelectedCNList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'IH_Invoice_Status',
          label: 'Invoice Status',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Invoice Name',
        },
        {
          prop: 'email',
          label: 'Email(Key in your testing email)',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],
      AuditDisabled: false,
    }
  },
  mounted() {
    this.initEvent()
    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  props: [
    'propCNListInt',
    'propCurrentSchoolID',
    'propCNListWithoutPayeeEmailInt',
    'propZipType',
    'propSpdSelection',
    'propAgentDetailAgentNameSearch',
    'propAgentDetailStudentNameSearch',
  ],
  methods: {
    async changeSelection(val) {
      this.spdSelection = val
    },
    initEvent() {
      let tmpagentdatailname = Cookies.get('agentdetailagentname')
      let tmpagentdetailstudentname = Cookies.get('agentdetailstudentname')

      if (tmpagentdatailname === 'undefined') {
        tmpagentdatailname = ''
      }
      if (tmpagentdetailstudentname === 'undefined') {
        tmpagentdetailstudentname = ''
      }

      this.searchagentdetailagentName = tmpagentdatailname
      this.searchagentdetailstudentname = tmpagentdetailstudentname

      this.CNListInt = this.propCNListInt
      this.currentSchoolID = this.propCurrentSchoolID
      this.CNListWithoutPayeeEmailInt = this.propCNListWithoutPayeeEmailInt
      this.zipType = this.propZipType
      this.spdSelection = this.propSpdSelection
      console.log(this.zipType)

      this.Search('AgentStudent')
    },

    //alexis
    async btnSaveAgentStudent(value) {
      if (value === 'No') {
        //this.$refs.invoice.hideModal();
        this.txtEditAgentDetail_AgentName = ''
        this.txtEditAgentDetail_StudentName = ''
        this.txtEditAgentDetail_StartDate = ''
        this.txtEditAgentDetail_EndDate = ''

        this.txtEditAgentDetail_SchoolFee = '0.00'
        this.txtEditAgentDetail_Remarks = ''

        this.txtEditAgentDetail_AgentID = ''
        this.txtEditAgentDetail_SChoolID = ''
        this.txtEditAgentDetail_CourseID = ''
        this.txtEditAgentDetail_StudentID = ''

        this.AgtStuStatus = 'Active'

        this.txtEditAgentDetail_EditID = ''
        this.$refs.showEditAgentDetailModal.hide()
      } else {
        if (!Number.isInteger(parseInt(this.txtEditAgentDetail_SchoolFee))) {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save - invalid school fee value',
          })
          return
        }

        this.$emit(
          'btnSaveAgentStudent',
          value,
          this.txtEditAgentDetail_EditID,
          this.txtEditAgentDetail_SchoolFee,
          this.txtEditAgentDetail_Remarks,
          this.AgtStuStatus,
          this.txtEditAgentDetail_AgentID,
          this.txtEditAgentDetail_SChoolID,
          this.txtEditAgentDetail_CourseID,
          this.txtEditAgentDetail_StudentID,
          'SaveAgentStudent',
        )

        this.txtEditAgentDetail_AgentName = ''
        this.txtEditAgentDetail_StudentName = ''
        this.txtEditAgentDetail_StartDate = ''
        this.txtEditAgentDetail_EndDate = ''
        this.txtEditAgentDetail_SchoolFee = '0.00'
        this.txtEditAgentDetail_Remarks = ''
        this.AgtStuStatus = 'Active'
        this.txtEditAgentDetail_EditID = ''

        this.txtEditAgentDetail_AgentID = ''
        this.txtEditAgentDetail_SChoolID = ''
        this.txtEditAgentDetail_CourseID = ''
        this.txtEditAgentDetail_StudentID = ''

        this.$refs.showEditAgentDetailModal.hide()

        await this.Search('AgentStudent')
      }
    },

    //alexis
    async Search(type) {
      try {
        this.clearTablesList()
        this.clearBModalList()
        //todo: to check empty input, force to input at least 1 datetime

        this.$vs.loading()
        const resp = await DataSource.shared.getAgentDetailList(this.searchagentdetailagentName, this.searchagentdetailstudentname, type)
        if (resp) {
          if (resp.code === '88') {
            window.location.replace('/')
          } else if (resp.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Search Agent Detail: Error',
            })
          } else if (resp.code === '2') {
            this.$notify.error({
              title: 'No Record',
              message: 'Students by Agent Details not found',
            })
          } else {
            this.CNListInt = []
            this.tempResp = resp.Table
            this.tempResp.forEach(m => {
              this.CNListInt.push(m)

              Cookies.set('agentdetailagentname', this.searchagentdetailagentName, { expires: 3 / 24 })
              Cookies.set('agentdetailstudentname', this.searchagentdetailstudentname, { expires: 3 / 24 })
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async clearTablesList() {
      this.CNListInt = []
      this.CNListWithoutPayeeEmailInt = []
    },
    async clearBModalList() {
      console.log('clearBModalList')
      this.spdSelection = []
      this.selectedCNListInt = []
    },
    async showBModal(mode) {
      if (mode == 'EditAgentDetail') {
        this.$refs.showEditAgentDetailModal.show()
      }

      /*
                try {
                    //todo: check if no checkbox selected
                    if (this.spdSelection.length < 1) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select at least 1 item!',
                        });
                    } else {
                        this.$refs.showBatchEmailConfirmationModal.show();
                        await this.getSelectedList();
                    }
                } catch (e) {
                    this.results = e;
                }
                */
    },
    async showBModalWithBreakdown() {
      try {
        if (this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showBatchEmailConfirmationModalWithBreakdown.show()
          await this.getSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    async getSelectedList() {
      this.selectedCNListInt = this.spdSelection
    },
    async downloadAsZip() {
      try {
        let spdList = []
        let selectedObjList = []
        spdList = this.spdSelection
        if (this.spdSelection.length < 1) {
          alert('Please select at least 1 item!')
        } else {
          this.$vs.loading()
          spdList.forEach(m => {
            let List = {
              IH_Invoice_No: m.IH_Invoice_No,
            }
            selectedObjList.push(List)
          })

          const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
          if (resp.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Cannot download files!',
            })
          } else {
            let byteChar = atob(resp.code)
            let byteNo = new Array(byteChar.length)
            for (let i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNo)
            let file = new Blob([byteArray], { type: 'application/zip;base64' })
            let fileUrl = URL.createObjectURL(file)
            window.location.href = fileUrl
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async downloadAllAsZip() {
      try {
        let spdList = []
        let selectedObjList = []
        spdList = this.CNListInt
        this.$vs.loading()
        spdList.forEach(m => {
          let List = {
            IH_Invoice_No: m.IH_Invoice_No,
          }
          selectedObjList.push(List)
        })

        const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Cannot download files!',
          })
        } else {
          let byteChar = atob(resp.code)
          let byteNo = new Array(byteChar.length)
          for (let i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i)
          }
          let byteArray = new Uint8Array(byteNo)
          let file = new Blob([byteArray], { type: 'application/zip;base64' })
          let fileUrl = URL.createObjectURL(file)
          window.location.href = fileUrl
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async getTestingSelectedList() {
      this.testingselectedCNListInt = this.spdSelection
    },
    //Testing items only: start
    async showTestBModal() {
      try {
        //todo: check if no checkbox selected
        if (this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showTestingBModal.show()
          await this.getTestingSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnSendEmail(value) {
      this.$emit('btnSendEmail', value)
    },
    async btnSendEmailWithBreakdown(value) {
      this.$emit('btnSendEmailWithBreakdown', value)
    },
    async btnTestingSendEmail(value) {
      this.$emit('btnTestingSendEmail', value)
    },
    async btnTestingSendEmailWithBreakdown(value) {
      this.$emit('btnTestingSendEmailWithBreakdown', value)
    },
  },
}
</script>
<style scoped></style>
<style></style>
